module.exports = __webpack_public_path__ + "static/img/online.1b6ccb3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online.webp
// module id = pfHs
// module chunks = 1